import { ActionDescriptor } from '../common/commonTypes';
import MergeAttributeForm from './MergeAttributeForm';

const mergeAttribute: ActionDescriptor = {
	FormComponent: MergeAttributeForm,
	actionTitle: 'Merge',
};

export default mergeAttribute;
